import { IPublishOfferErrors } from '../types';
import { IPublishOfferResponseErrors } from '../../../repositories/monolith-python/v2/publish-offer';

export const mapErrors = (errors: IPublishOfferResponseErrors | null | undefined): IPublishOfferErrors => {
  if (!errors) {
    return {};
  }

  const errorKeys = Object.keys(errors);

  return errorKeys.reduce((stash, key) => {
    const errorList = errors[key];

    return {
      ...stash,
      [key]: errorList.map(({ code, messageRu }) => ({
        code,
        message: messageRu,
      })),
    };
  }, {});
};
